import { RegionType } from "graphql/generated";

interface Props {
  countries: Array<RegionType>;
  children: React.ReactElement;
}

export const CountryComponentWrapper = ({ countries, children }: Props) => {
  if (countries.includes(process.env.NEXT_PUBLIC_COUNTRY as RegionType)) {
    return children;
  }
  return <></>;
};
